export const STEP_EMAIL = 'email'
export const STEP_OTP = 'otp'
export const STORAGE_KEY = 'otp_pending_email'

export const ERROR_MESSAGES = {
  EMAIL_REQUIRED: 'Please enter your email address.',
  OTP_SEND_FAILED: 'Failed to send OTP. Please try again.',
  OTP_VERIFY_FAILED: 'Invalid OTP. Please try again.',
  OTP_RESEND_FAILED: 'Failed to resend OTP. Please try again.',
  OTP_TOO_MANY_ATTEMPTS:
    'Too many attempts. Your account is temporarily locked. Please try again after 24 hours.',
  SUBMITTAL_NOT_FOUND: 'Submission no longer available',
}

export const TOAST_MESSAGES = {
  OTP_ALREADY_SENT:
    'A code was already sent to this address. Enter it or wait for the resend timer.',
  OTP_RECENTLY_SENT:
    'A code was recently sent. Please wait for the timer to expire before requesting another.',
  OTP_RESENT: 'A new verification code has been sent to your email.',
}
